
export const PRODUCTS_ICONS_MAP = {
  WellnessIncentiveAccounts: "piggy-bank",
  MassTransit: "glasses",
  Parking: "hand-holding-dollar",
} as const;
